/** Rutas de encuestas: bandeja (todos) + admin (directiva) + responder standalone. */
export default [
  {
    path: "/user/encuestas/pendientes",
    name: "encuestas-pendientes",
    component: () =>
      import("@/views/user/encuestas/SurveyInboxView.vue"),
    meta: {
      requiresAuth: true,
      requiresCurso: true,
    },
  },
  {
    path: "/user/encuestas",
    component: () =>
      import("@/views/user/encuestas/SurveyAdminLayout.vue"),
    meta: {
      requiresAuth: true,
      requiresCurso: true,
      requiresDirectiva: true,
    },
    children: [
      {
        path: "",
        name: "encuestas-list",
        component: () =>
          import("@/views/user/encuestas/SurveyAdminListView.vue"),
      },
      {
        path: "nueva",
        name: "encuestas-nueva",
        component: () =>
          import("@/views/user/encuestas/SurveyBuilderView.vue"),
      },
      {
        path: ":surveyId/editar",
        name: "encuestas-editar",
        component: () =>
          import("@/views/user/encuestas/SurveyBuilderView.vue"),
        props: true,
      },
      {
        path: ":surveyId/preview",
        name: "encuestas-preview",
        component: () =>
          import("@/views/user/encuestas/SurveyPreviewView.vue"),
        props: true,
      },
      {
        path: ":surveyId/resultados",
        name: "encuestas-resultados",
        component: () =>
          import("@/views/user/encuestas/SurveyResultsView.vue"),
        props: true,
      },
    ],
  },
];

/** Layout standalone (Android Browser / web) — sin menú admin. */
export const surveyRespondRoute = {
  path: "/encuestas/:surveyId/responder",
  name: "encuesta-responder",
  component: () => import("@/views/encuestas/SurveyRespondView.vue"),
  props: true,
  meta: {
    /** Puede abrir con ?session=ss_… sin Cognito en el navegador externo */
    requiresAuth: false,
  },
};
